export default __webpack_public_path__ + "static/media/START_Compression.e79c1705.pdf";